var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/reward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M3 10.5C3 9.55719 3 9.08579 3.29289 8.79289C3.58579 8.5 4.05719 8.5 5 8.5H19C19.9428 8.5 20.4142 8.5 20.7071 8.79289C21 9.08579 21 9.55719 21 10.5V12C21 12.4659 21 12.6989 20.9239 12.8827C20.8224 13.1277 20.6277 13.3224 20.3827 13.4239C20.1989 13.5 19.9659 13.5 19.5 13.5V13.5C19.0341 13.5 18.8011 13.5 18.6173 13.5761C18.3723 13.6776 18.1776 13.8723 18.0761 14.1173C18 14.3011 18 14.5341 18 15V18.5C18 19.4428 18 19.9142 17.7071 20.2071C17.4142 20.5 16.9428 20.5 16 20.5H8C7.05719 20.5 6.58579 20.5 6.29289 20.2071C6 19.9142 6 19.4428 6 18.5V15C6 14.5341 6 14.3011 5.92388 14.1173C5.82239 13.8723 5.62771 13.6776 5.38268 13.5761C5.19891 13.5 4.96594 13.5 4.5 13.5V13.5C4.03406 13.5 3.80109 13.5 3.61732 13.4239C3.37229 13.3224 3.17761 13.1277 3.07612 12.8827C3 12.6989 3 12.4659 3 12V10.5Z",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M5 13.5H19",
    stroke: "#626262",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M12 7.5L12 20.5",
    stroke: "#626262",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 208",
    d: "M12 7.5L11.1214 6.62144C10.0551 5.55514 8.75521 4.75174 7.3246 4.27487V4.27487C6.18099 3.89366 5 4.74487 5 5.95035V6.13246C5 6.94914 5.52259 7.6742 6.29737 7.93246L8 8.5",
    stroke: "#626262",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 209",
    d: "M12 7.5L12.8786 6.62144C13.9449 5.55514 15.2448 4.75174 16.6754 4.27487V4.27487C17.819 3.89366 19 4.74487 19 5.95035V6.13246C19 6.94914 18.4774 7.6742 17.7026 7.93246L16 8.5",
    stroke: "#626262",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardImg);
export default __webpack_public_path__ + "static/media/rewardImg.530019dca7e80e83de8dde631ac4b2ca.svg";
export { ForwardRef as ReactComponent };